import type { ReactNode } from "react"
import { useAuth } from "../contexts/AuthContext"

/**
 * Wraps a route subtree and shows an Access Denied view to any caller that
 * isn't a global admin. Use for `/admin/*` and other system-wide routes.
 * Assumes AuthGuard has already verified authentication.
 */
export function RequireGlobalAdmin({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-content-2">Loading...</div>
      </div>
    )
  }

  if (!user?.isGlobalAdmin) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="mb-2 font-display text-2xl font-bold text-content">Access Denied</h1>
          <p className="text-content-2">You must be a global admin to access this area.</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
